import { Box } from '@mui/material';

import { BaseChainsHeader } from 'domains/chains/components/BaseChainsHeader';
import { ChainsList } from 'modules/common/components/ChainsList';
import { ChainsPublicStatsProvider } from 'modules/chains/components/ChainsPublicStatsProvider';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { SSRChainsLinksGenerator } from 'domains/chains/components/SSRChainsLinksGenerator';
import { UpgradeAccountDialog } from 'modules/common/components/UpgradeAccountDialog';
import { UpgradePlanBanner } from 'modules/common/components/UpgradePlanBanner';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { BaseChains } from '../BaseChains';
import { IChainsViewProps } from './PublicChainsTypes';
import { PublicChainCard } from './components/PublicChainCard';
import { publicChainsTranslation } from './translation';
import { usePublicChains } from './hooks/usePublicChains';

export const PublicChains = ({
  chainsViewTabs,
  selectedChainsViewTab,
}: IChainsViewProps) => {
  const {
    chains,
    isPublicChainsChecked,
    loading,
    onPublicChainsCheckboxClick,
    processedChains,
    searchContent,
    setSearchContent,
    setSortType,
    sortType,
    statsParams,
    timeframe,
  } = usePublicChains();

  const {
    isOpened: isPromoDialogOpened,
    onClose: onPromoDialogClose,
    onOpen: onPromoDialogOpen,
  } = useDialog();

  const { keys, t } = useTranslation(publicChainsTranslation);

  return (
    <>
      <BaseChains loading={loading} top={<UpgradePlanBanner />}>
        <NoSSRGuard
          fallback={
            <Box id="chainListWrap">
              <SSRChainsLinksGenerator chains={chains} />
            </Box>
          }
        >
          <>
            <BaseChainsHeader
              sortType={sortType}
              setSortType={setSortType}
              searchContent={searchContent}
              setSearchContent={setSearchContent}
              chainsViewTabs={chainsViewTabs}
              selectedChainsViewTab={selectedChainsViewTab}
              isPublicChainsChecked={isPublicChainsChecked}
              onPublicChainsCheckboxClick={onPublicChainsCheckboxClick}
            />
            <ChainsList
              hasNoResult={processedChains?.length === 0}
              isLoading={loading}
              view={selectedChainsViewTab?.id}
              timeframe={timeframe}
              isPublicLayout
              tooltipText={t(keys.requestsTooltip)}
            >
              <ChainsPublicStatsProvider value={statsParams}>
                {processedChains.map(chain => {
                  return (
                    <PublicChainCard
                      chain={chain}
                      key={chain.id}
                      onOpenUpgradeModal={onPromoDialogOpen}
                      timeframe={timeframe}
                      view={selectedChainsViewTab?.id}
                    />
                  );
                })}
              </ChainsPublicStatsProvider>
            </ChainsList>
          </>
        </NoSSRGuard>
      </BaseChains>
      <UpgradeAccountDialog
        isOpened={isPromoDialogOpened}
        onClose={onPromoDialogClose}
      />
    </>
  );
};
